import { global } from '@storybook/global';

global.STORYBOOK_ENV="angular";
